/**
 * Applies a gaussian-style distortion
 * @param {Object} normalizedPoint - Normalized {x, y} point (0-1)
 * @param {number} strength - Amount of movement
 * @returns {Object} Distorted point {x, y}
 */
export const movement = ({x, y}, strength) => {
  if (x !== undefined && y !== undefined) {
    return {
      x: x + Math.random() * strength,
      y: y + Math.random() * strength,
    };
  } else {
    return { x, y };
  }
};
